import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Posts.css';
import postsByIndex from '../../core/postsByIndex';
import externalPostsByIndex from '../../core/externalPostsByIndex';
import Link from '../Link';

const rows = postsByIndex
  .filter((post) => !post.hide)
  .map((post) => {
    const { title, path, date } = post;
    return (
      <tr key={title}>
        <td><Link to={`/posts${path}`}>{title}</Link></td>
        <td className={s.date}>{date}</td>
      </tr>
    );
  });

const externalRows = externalPostsByIndex.map((post) => {
  const { title, url, date } = post;
  return (
    <tr key={title}>
      <td><Link to={url}>{title}</Link></td>
      <td className={s.date}>{date}</td>
    </tr>
  );
});

class Posts extends React.Component {

  static propTypes = {};

  makeTable(title, tableRows) {
    return (
      <table className={s.table}>
        <colgroup>
          <col />
          <col className={s.dateCol} />
        </colgroup>
        <tbody>
          <tr className={s.tableHeader}>
            <td>{title}</td>
            <td className={s.date}>Date</td>
          </tr>
          {tableRows}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <div>
        {this.makeTable('Post', rows)}
        <br />
        {this.makeTable('External Post', externalRows)}
      </div>
    );
  }
}

export default withStyles(s)(Posts);



// WEBPACK FOOTER //
// src/components/Posts/Posts.js